/** players: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "stOnline": "Online",
  "stOffline": "Offline",
  "stReconnecting": "Reconnecting",
  "stReconnectingHint": "Its connection dropped a moment ago. It keeps playing its saved content and usually reconnects within a minute or two (players in lifts drop often). Offline after 3 minutes without contact.",
  "stNever": "Waiting for first contact",
  "stUnpaired": "Not paired",
  "connecting": "Connecting…",
  "unknownGroup": "Unknown group",
  "sumAll": "All players",
  "sumAttention": "Need attention",
  "sumAttentionHint": "Players with broken content: files that can't download or won't play. Offline players aren't counted: they catch up when they're back.",
  "colName": "Name",
  "colStatus": "Status",
  "colLastSeen": "Last heard from",
  "colDevice": "Device",
  "colGroups": "Groups",
  "colVersion": "App",
  "colContent": "In queue",
  "newPlayer": "New Player",
  "replaceDeviceOf": "Replace device · {name}",
  "pairDeviceOf": "Pair device · {name}",
  "tagsSaved": "Tags saved",
  "coordsBoth": "Enter both latitude and longitude, or neither.",
  "latRange": "Latitude must be between −90 and 90.",
  "lngRange": "Longitude must be between −180 and 180.",
  "tab_status": "Player status",
  "tab_published": "Play queue",
  "tab_activity": "Activity",
  "tab_resources": "Resources",
  "tab_logs": "Errors & warnings",
  "tab_live": "Live control",
  "tab_content": "Content & settings",
  "unpairQ": "Unpair the device from “{name}”? It will switch to its standby reel until re-paired.",
  "deleteQ": "Delete “{name}”? This frees its player seat and disconnects its device.",
  "title": "Players",
  "subtitle": "{org} · every player in your fleet, live.",
  "seats": "Player seats",
  "seatsUsed": "{used} / {total} used",
  "filterStatus": "Filter by status",
  "searchPlayers": "Search players",
  "searchPh": "Search name, device, group, time zone…",
  "filterGroup": "Filter by group",
  "allGroups": "All groups",
  "allTags": "All tags",
  "filterTag": "Filter by tag",
  "loadingMore": "Loading more…",
  "noGroup": "No group",
  "nSelected": "{n} selected",
  "bulkLabel": "Add selected players to a player group",
  "addToGroup": "Add to group…",
  "removeAll": "Remove from all groups",
  "saving": "Saving…",
  "apply": "Apply",
  "clear": "Clear",
  "players": "Players",
  "seenAgo": "seen {ago}",
  "downloading": "Downloading {pct} % · {done} of {total} files",
  "standby": "Showing standby (no content to play)",
  "contentRev": "Play queue (revision {rev})",
  "nContents": "{n} Content | {n} Contents",
  "quickEdit": "Quick edit",
  "quickView": "Quick view",
  "quickEditName": "Quick edit {name}",
  "quickViewName": "Quick view {name}",
  "liveControl": "Live control",
  "liveFor": "Live control for {name}",
  "replaceDevice": "Replace device",
  "pairDevice": "Pair device",
  "replaceOn": "Replace device on {name}",
  "pairTo": "Pair device to {name}",
  "openDetails": "Open details",
  "openDetailsFor": "Open details for {name}",
  "noPlayers": "No players yet",
  "installHint": "Install the Displaro player on an Android TV or box — it shows a 6-character code.",
  "enterWithNew": "Enter it with “New Player”.",
  "noMatch": "No players match",
  "clearFilters": "Clear filters",
  "showing": "Showing {n} of {total} player · updates every 5 s | Showing {n} of {total} players · updates every 5 s",
  "enterCode": "Enter the code shown on the TV.",
  "settings": "Settings",
  "adminsOnly": "Only admins can change player settings.",
  "name": "Name",
  "timeZone": "Time zone",
  "tzHint": "Content runs on the player in this time zone, even offline.",
  "groups": "Groups",
  "moveUp": "Move {name} up",
  "removeFrom": "Remove from {name}",
  "addToGroupSr": "Add to group",
  "addAnother": "Add another group…",
  "addToAGroup": "Add to a group…",
  "groupsHint": "A player can be in several groups. Each group's content plays after the player's own, in this order.",
  "location": "Location",
  "latitude": "Latitude",
  "longitude": "Longitude",
  "locHint": "Used by Prayer Time and Weather apps set to “Player Location”.",
  "tags": "Tags",
  "saveTags": "Save tags",
  "cancel": "Cancel",
  "tagsHint": "Content published to a tag reaches every player with it.",
  "customAttributes": "Custom attributes",
  "manage": "Manage",
  "device": "Device",
  "model": "Model",
  "content": "Content",
  "revision": "revision {n}",
  "notPublished": "not published yet",
  "paired": "Paired",
  "firstContact": "First contact",
  "waitingPlayer": "waiting for the player…",
  "noDevice": "No device is paired to this player.",
  "unpair": "Unpair",
  "open": "Open",
  "deletePlayer": "Delete player",
  "deleteHint": "Frees its player seat and disconnects its device.",
  "deleteName": "Delete “{name}”",
  "close": "Close",
  "saveChanges": "Save changes"
};
const ar: typeof en = {
  "stOnline": "متصل",
  "stOffline": "غير متصل",
  "stReconnecting": "يعيد الاتصال",
  "stReconnectingHint": "انقطع اتصاله قبل لحظات. يواصل عرض المحتوى المحفوظ ويعود عادةً خلال دقيقة أو دقيقتين (المشغّلات في المصاعد تنقطع كثيرًا). يُعدّ غير متصل بعد 3 دقائق دون تواصل.",
  "stNever": "بانتظار أول اتصال",
  "stUnpaired": "غير مقترن",
  "connecting": "جارٍ الاتصال…",
  "unknownGroup": "مجموعة غير معروفة",
  "sumAll": "كل المشغلات",
  "sumAttention": "تحتاج انتباهًا",
  "sumAttentionHint": "مشغّلات بمحتوى معطّل: ملفات لا تُنزَّل أو لا تُعرض. لا تُحسب المشغّلات غير المتصلة: تلحق بالتحديث عند عودتها.",
  "colName": "الاسم",
  "colStatus": "الحالة",
  "colLastSeen": "آخر ظهور",
  "colDevice": "الجهاز",
  "colGroups": "المجموعات",
  "colVersion": "التطبيق",
  "colContent": "في القائمة",
  "newPlayer": "مشغل جديد",
  "replaceDeviceOf": "استبدال الجهاز · {name}",
  "pairDeviceOf": "إقران جهاز · {name}",
  "tagsSaved": "تم حفظ الوسوم",
  "coordsBoth": "أدخل خط العرض وخط الطول معًا، أو اتركهما فارغين.",
  "latRange": "يجب أن يكون خط العرض بين −90 و90.",
  "lngRange": "يجب أن يكون خط الطول بين −180 و180.",
  "tab_status": "حالة المشغل",
  "tab_published": "قائمة التشغيل",
  "tab_activity": "النشاط",
  "tab_resources": "الموارد",
  "tab_logs": "الأخطاء والتحذيرات",
  "tab_live": "التحكم المباشر",
  "tab_content": "المحتوى والإعدادات",
  "unpairQ": "إلغاء إقران الجهاز من «{name}»؟ سيعرض شاشة الانتظار حتى يُعاد إقرانه.",
  "deleteQ": "حذف «{name}»؟ يحرر ذلك مقعد المشغل ويفصل جهازه.",
  "title": "المشغلات",
  "subtitle": "{org} · كل مشغلات أسطولك، مباشرة.",
  "seats": "مقاعد المشغلات",
  "seatsUsed": "{used} / {total} مستخدمة",
  "filterStatus": "التصفية حسب الحالة",
  "searchPlayers": "البحث في المشغلات",
  "searchPh": "ابحث بالاسم أو الجهاز أو المجموعة أو المنطقة الزمنية…",
  "filterGroup": "التصفية حسب المجموعة",
  "allGroups": "كل المجموعات",
  "allTags": "كل الوسوم",
  "filterTag": "التصفية حسب الوسم",
  "loadingMore": "جارٍ تحميل المزيد…",
  "noGroup": "بلا مجموعة",
  "nSelected": "{n} محدد",
  "bulkLabel": "إضافة المشغلات المحددة إلى مجموعة",
  "addToGroup": "إضافة إلى مجموعة…",
  "removeAll": "إزالة من كل المجموعات",
  "saving": "جارٍ الحفظ…",
  "apply": "تطبيق",
  "clear": "مسح",
  "players": "المشغلات",
  "seenAgo": "ظهر {ago}",
  "downloading": "جارٍ التنزيل {pct} % · {done} من {total} ملفات",
  "standby": "يعرض شاشة الانتظار (لا يوجد محتوى للتشغيل)",
  "contentRev": "قائمة التشغيل (المراجعة {rev})",
  "nContents": "لا محتوى | محتوى واحد | محتويان | {n} محتويات | {n} محتوى | {n} محتوى",
  "quickEdit": "تعديل سريع",
  "quickView": "عرض سريع",
  "quickEditName": "تعديل سريع لـ {name}",
  "quickViewName": "عرض سريع لـ {name}",
  "liveControl": "التحكم المباشر",
  "liveFor": "التحكم المباشر لـ {name}",
  "replaceDevice": "استبدال الجهاز",
  "pairDevice": "إقران جهاز",
  "replaceOn": "استبدال الجهاز في {name}",
  "pairTo": "إقران جهاز بـ {name}",
  "openDetails": "فتح التفاصيل",
  "openDetailsFor": "فتح تفاصيل {name}",
  "noPlayers": "لا توجد مشغلات بعد",
  "installHint": "ثبّت مشغل Displaro على تلفاز أو جهاز Android — سيعرض رمزًا من ٦ أحرف.",
  "enterWithNew": "أدخله عبر «مشغل جديد».",
  "noMatch": "لا توجد مشغلات مطابقة",
  "clearFilters": "مسح عوامل التصفية",
  "showing": "عرض {n} من {total} · يتحدث كل ٥ ث | عرض {n} من مشغل واحد · يتحدث كل ٥ ث | عرض {n} من مشغلين · يتحدث كل ٥ ث | عرض {n} من {total} مشغلات · يتحدث كل ٥ ث | عرض {n} من {total} مشغلًا · يتحدث كل ٥ ث | عرض {n} من {total} مشغل · يتحدث كل ٥ ث",
  "enterCode": "أدخل الرمز الظاهر على التلفاز.",
  "settings": "الإعدادات",
  "adminsOnly": "يمكن للمسؤولين فقط تغيير إعدادات المشغل.",
  "name": "الاسم",
  "timeZone": "المنطقة الزمنية",
  "tzHint": "يعمل المحتوى على المشغل بهذه المنطقة الزمنية، حتى دون اتصال.",
  "groups": "مجموعات المشغلات",
  "moveUp": "نقل {name} لأعلى",
  "removeFrom": "إزالة من {name}",
  "addToGroupSr": "إضافة إلى مجموعة",
  "addAnother": "إضافة مجموعة أخرى…",
  "addToAGroup": "إضافة إلى مجموعة…",
  "groupsHint": "يمكن أن يكون المشغل في عدة مجموعات. يُعرض محتوى كل مجموعة بعد محتوى المشغل نفسه، بهذا الترتيب.",
  "location": "الموقع",
  "latitude": "خط العرض",
  "longitude": "خط الطول",
  "locHint": "تستخدمه تطبيقات أوقات الصلاة والطقس المضبوطة على «موقع المشغل».",
  "tags": "الوسوم",
  "saveTags": "حفظ الوسوم",
  "cancel": "إلغاء",
  "tagsHint": "يصل المحتوى المنشور على وسم إلى كل مشغل يحمله.",
  "customAttributes": "السمات المخصصة",
  "manage": "إدارة",
  "device": "الجهاز",
  "model": "الطراز",
  "content": "المحتوى",
  "revision": "المراجعة {n}",
  "notPublished": "لم يُنشر بعد",
  "paired": "الإقران",
  "firstContact": "أول اتصال",
  "waitingPlayer": "بانتظار المشغل…",
  "noDevice": "لا يوجد جهاز مقترن بهذا المشغل.",
  "unpair": "إلغاء الإقران",
  "open": "فتح",
  "deletePlayer": "حذف المشغل",
  "deleteHint": "يحرر مقعد المشغل ويفصل جهازه.",
  "deleteName": "حذف «{name}»",
  "close": "إغلاق",
  "saveChanges": "حفظ التغييرات"
};
export default { en, ar };
